/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DownloadFileInfo,
    DownloadFileInfoFromJSON,
    DownloadFileInfoToJSON,
    MessageCaptureType,
    MessageCaptureTypeFromJSON,
    MessageCaptureTypeToJSON,
    PostSearchDataItem,
    PostSearchDataItemFromJSON,
    PostSearchDataItemToJSON,
    PostSearchDataItemQuery,
    PostSearchDataItemQueryFromJSON,
    PostSearchDataItemQueryToJSON,
    ShoppingDiagnosticsData,
    ShoppingDiagnosticsDataFromJSON,
    ShoppingDiagnosticsDataToJSON,
    ShoppingDiagnosticsFormConfiguration,
    ShoppingDiagnosticsFormConfigurationFromJSON,
    ShoppingDiagnosticsFormConfigurationToJSON,
    ShoppingDiagnosticsRequest,
    ShoppingDiagnosticsRequestFromJSON,
    ShoppingDiagnosticsRequestToJSON,
    ShoppingDiagnosticsRequestValidationData,
    ShoppingDiagnosticsRequestValidationDataFromJSON,
    ShoppingDiagnosticsRequestValidationDataToJSON,
    TechLogsValidationData,
    TechLogsValidationDataFromJSON,
    TechLogsValidationDataToJSON,
    TechLogsValidationRequest,
    TechLogsValidationRequestFromJSON,
    TechLogsValidationRequestToJSON,
} from '../models';

export interface ApiShoppingDiagnosticsGetDiagnosticsDataGetRequest {
    correlationId?: string;
}

export interface ApiShoppingDiagnosticsGetDiagnosticsDataNewGetRequest {
    correlationId?: string;
}

export interface ApiShoppingDiagnosticsGetPostSearchDataItemsPostRequest {
    postSearchDataItemQuery?: PostSearchDataItemQuery;
}

export interface ApiShoppingDiagnosticsGetProviderMessageAllGetRequest {
    correlationId?: string;
}

export interface ApiShoppingDiagnosticsGetProviderMessageGetRequest {
    correlationId?: string;
    requestId?: string;
    request?: boolean;
    messageType?: MessageCaptureType;
}

export interface ApiShoppingDiagnosticsShoppingPostRequest {
    shoppingDiagnosticsRequest?: ShoppingDiagnosticsRequest;
}

export interface ApiShoppingDiagnosticsValidateShoppingPostRequest {
    shoppingDiagnosticsRequest?: ShoppingDiagnosticsRequest;
}

export interface ApiShoppingDiagnosticsValidateTechLogsPostRequest {
    techLogsValidationRequest?: TechLogsValidationRequest;
}

/**
 * no description
 */
export class ShoppingDiagnosticsApi extends runtime.BaseAPI {

    /**
     */
    async apiShoppingDiagnosticsConfigurationGetRaw(): Promise<runtime.ApiResponse<ShoppingDiagnosticsFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingDiagnosticsFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingDiagnosticsConfigurationGet(): Promise<ShoppingDiagnosticsFormConfiguration> {
        const response = await this.apiShoppingDiagnosticsConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsGetDiagnosticsDataGetRaw(requestParameters: ApiShoppingDiagnosticsGetDiagnosticsDataGetRequest): Promise<runtime.ApiResponse<ShoppingDiagnosticsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.correlationId !== undefined) {
            queryParameters['correlationId'] = requestParameters.correlationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/GetDiagnosticsData`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingDiagnosticsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingDiagnosticsGetDiagnosticsDataGet(requestParameters: ApiShoppingDiagnosticsGetDiagnosticsDataGetRequest): Promise<ShoppingDiagnosticsData> {
        const response = await this.apiShoppingDiagnosticsGetDiagnosticsDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsGetDiagnosticsDataNewGetRaw(requestParameters: ApiShoppingDiagnosticsGetDiagnosticsDataNewGetRequest): Promise<runtime.ApiResponse<ShoppingDiagnosticsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.correlationId !== undefined) {
            queryParameters['correlationId'] = requestParameters.correlationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/GetDiagnosticsDataNew`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingDiagnosticsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingDiagnosticsGetDiagnosticsDataNewGet(requestParameters: ApiShoppingDiagnosticsGetDiagnosticsDataNewGetRequest): Promise<ShoppingDiagnosticsData> {
        const response = await this.apiShoppingDiagnosticsGetDiagnosticsDataNewGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsGetPostSearchDataItemsPostRaw(requestParameters: ApiShoppingDiagnosticsGetPostSearchDataItemsPostRequest): Promise<runtime.ApiResponse<Array<PostSearchDataItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/GetPostSearchDataItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostSearchDataItemQueryToJSON(requestParameters.postSearchDataItemQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostSearchDataItemFromJSON));
    }

    /**
     */
    async apiShoppingDiagnosticsGetPostSearchDataItemsPost(requestParameters: ApiShoppingDiagnosticsGetPostSearchDataItemsPostRequest): Promise<Array<PostSearchDataItem>> {
        const response = await this.apiShoppingDiagnosticsGetPostSearchDataItemsPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsGetProviderMessageAllGetRaw(requestParameters: ApiShoppingDiagnosticsGetProviderMessageAllGetRequest): Promise<runtime.ApiResponse<Array<DownloadFileInfo>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.correlationId !== undefined) {
            queryParameters['correlationId'] = requestParameters.correlationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/GetProviderMessageAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DownloadFileInfoFromJSON));
    }

    /**
     */
    async apiShoppingDiagnosticsGetProviderMessageAllGet(requestParameters: ApiShoppingDiagnosticsGetProviderMessageAllGetRequest): Promise<Array<DownloadFileInfo>> {
        const response = await this.apiShoppingDiagnosticsGetProviderMessageAllGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsGetProviderMessageGetRaw(requestParameters: ApiShoppingDiagnosticsGetProviderMessageGetRequest): Promise<runtime.ApiResponse<DownloadFileInfo>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.correlationId !== undefined) {
            queryParameters['correlationId'] = requestParameters.correlationId;
        }

        if (requestParameters.requestId !== undefined) {
            queryParameters['requestId'] = requestParameters.requestId;
        }

        if (requestParameters.request !== undefined) {
            queryParameters['request'] = requestParameters.request;
        }

        if (requestParameters.messageType !== undefined) {
            queryParameters['messageType'] = requestParameters.messageType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/GetProviderMessage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFileInfoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingDiagnosticsGetProviderMessageGet(requestParameters: ApiShoppingDiagnosticsGetProviderMessageGetRequest): Promise<DownloadFileInfo> {
        const response = await this.apiShoppingDiagnosticsGetProviderMessageGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsShoppingPostRaw(requestParameters: ApiShoppingDiagnosticsShoppingPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/Shopping`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShoppingDiagnosticsRequestToJSON(requestParameters.shoppingDiagnosticsRequest),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiShoppingDiagnosticsShoppingPost(requestParameters: ApiShoppingDiagnosticsShoppingPostRequest): Promise<string> {
        const response = await this.apiShoppingDiagnosticsShoppingPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsValidateShoppingPostRaw(requestParameters: ApiShoppingDiagnosticsValidateShoppingPostRequest): Promise<runtime.ApiResponse<ShoppingDiagnosticsRequestValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/ValidateShopping`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShoppingDiagnosticsRequestToJSON(requestParameters.shoppingDiagnosticsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingDiagnosticsRequestValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingDiagnosticsValidateShoppingPost(requestParameters: ApiShoppingDiagnosticsValidateShoppingPostRequest): Promise<ShoppingDiagnosticsRequestValidationData> {
        const response = await this.apiShoppingDiagnosticsValidateShoppingPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiShoppingDiagnosticsValidateTechLogsPostRaw(requestParameters: ApiShoppingDiagnosticsValidateTechLogsPostRequest): Promise<runtime.ApiResponse<TechLogsValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ShoppingDiagnostics/ValidateTechLogs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TechLogsValidationRequestToJSON(requestParameters.techLogsValidationRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TechLogsValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingDiagnosticsValidateTechLogsPost(requestParameters: ApiShoppingDiagnosticsValidateTechLogsPostRequest): Promise<TechLogsValidationData> {
        const response = await this.apiShoppingDiagnosticsValidateTechLogsPostRaw(requestParameters);
        return await response.value();
    }

}
